import {useCallback, useMemo} from "react";
import Home from "./home";

const unwrap = (response) => response?.data ?? response ?? null;

export function useHome() {
    const home = useMemo(() => new Home(), []);

    const getHome = useCallback(async (workspaceId) => (
        unwrap(await home.getHome(workspaceId))
    ), [home]);

    const addFocusItem = useCallback(async (workspaceId, taskId, expectedVersion) => (
        unwrap(await home.addFocusItem(workspaceId, taskId, expectedVersion))
    ), [home]);

    const removeFocusItem = useCallback(async (workspaceId, focusItemId, expectedVersion) => (
        unwrap(await home.removeFocusItem(workspaceId, focusItemId, expectedVersion))
    ), [home]);

    const reorderFocusItems = useCallback(async (workspaceId, orderedFocusItemIds, expectedVersion) => (
        unwrap(await home.reorderFocusItems(workspaceId, orderedFocusItemIds, expectedVersion))
    ), [home]);

    const startFocusSession = useCallback(async (workspaceId, taskId, targetDurationSeconds) => (
        unwrap(await home.startFocusSession(workspaceId, taskId, targetDurationSeconds))
    ), [home]);

    const getCurrentFocusSession = useCallback(async (workspaceId) => (
        unwrap(await home.getCurrentFocusSession(workspaceId))
    ), [home]);

    const getActiveFocusSessions = useCallback(async (workspaceId) => (
        unwrap(await home.getActiveFocusSessions(workspaceId)) || []
    ), [home]);

    const mutateFocusSession = useCallback(async (workspaceId, sessionId, action, expectedVersion, data) => (
        unwrap(await home.mutateFocusSession(workspaceId, sessionId, action, expectedVersion, data))
    ), [home]);

    return useMemo(() => ({
        getHome,
        addFocusItem,
        removeFocusItem,
        reorderFocusItems,
        startFocusSession,
        getCurrentFocusSession,
        getActiveFocusSessions,
        mutateFocusSession,
    }), [addFocusItem, getActiveFocusSessions, getCurrentFocusSession, getHome, mutateFocusSession, removeFocusItem, reorderFocusItems, startFocusSession]);
}
